export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const JWT_ISSUED = "JWT_ISSUED";
export const PROFILE_UPDATED_BY_FORM = "PROFILE_UPDATED_BY_FORM";

export const TOGGLE_SETTING_UI_SIDEBAR = "TOGGLE_SETTING_UI_SIDEBAR";
export const SYSTEM_BOOT_RESOURCES_LOADED = "SYSTEM_BOOT_RESOURCES_LOADED";

export const WAREHOUSE_LIST_FETCHED = "WAREHOUSE_LIST_FETCHED";
export const WAREHOUSE_MODEL_LOADED = "WAREHOUSE_MODEL_LOADED";
export const WAREHOUSE_MODEL_UPDATED_BY_FORM = "WAREHOUSE_MODEL_UPDATED_BY_FORM";
export const NEW_WAREHOUSE_CREATED = "NEW_WAREHOUSE_CREATED";
export const EXISTING_WAREHOUSE_UPDATED = "EXISTING_WAREHOUSE_UPDATED";
export const WAREHOUSE_MODEL_UPDATED_ON_SERVER = "WAREHOUSE_MODEL_UPDATED_ON_SERVER";

export const RELATION_LIST_FETCHED = "RELATION_LIST_FETCHED";
export const RELATION_MODEL_LOADED = "RELATION_MODEL_LOADED";
export const RELATION_MODEL_UPDATED_BY_FORM = "RELATION_MODEL_UPDATED_BY_FORM";
export const RELATION_MODEL_UPDATED_ON_SERVER = "RELATION_MODEL_UPDATED_ON_SERVER";
export const RELATION_ADDRESS_MODEL_SELECTED = "RELATION_ADDRESS_MODEL_SELECTED";
export const RELATION_ADDRESS_MODEL_UPDATED_BY_FORM = "RELATION_ADDRESS_MODEL_UPDATED_BY_FORM";
export const RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER = "RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER";
export const RELATION_CONTACT_MODEL_SELECTED = "RELATION_CONTACT_MODEL_SELECTED";
export const RELATION_CONTACT_MODEL_UPDATED_BY_FORM = "RELATION_CONTACT_MODEL_UPDATED_BY_FORM";
export const RELATION_CONTACT_MODEL_UPDATED_ON_SERVER = "RELATION_CONTACT_MODEL_UPDATED_ON_SERVER";
export const RELATION_PRICING_MODEL_SELECTED = "RELATION_PRICING_MODEL_SELECTED";
export const RELATION_PRICING_MODEL_UPDATED_BY_FORM = "RELATION_PRICING_MODEL_UPDATED_BY_FORM";
export const RELATION_PRICING_MODEL_UPDATED_ON_SERVER = "RELATION_PRICING_MODEL_UPDATED_ON_SERVER";
export const RELATION_MODEL_ADDRESS_CREATED = "RELATION_MODEL_ADDRESS_CREATED";
export const RELATION_MODEL_ADDRESS_UPDATED = "RELATION_MODEL_ADDRESS_UPDATED";
export const RELATION_MODEL_CONTACT_CREATED = "RELATION_MODEL_CONTACT_CREATED";
export const RELATION_MODEL_CONTACT_UPDATED = "RELATION_MODEL_CONTACT_UPDATED";
export const RELATION_MODEL_PRICING_CREATED = "RELATION_MODEL_PRICING_CREATED";
export const RELATION_MODEL_PRICING_UPDATED = "RELATION_MODEL_PRICING_UPDATED";
export const RELATION_MODEL_PRICING_DELETED = "RELATION_MODEL_PRICING_DELETED";
export const UNMAPPED_WOO_CUSTOMER_LOADED = "UNMAPPED_WOO_CUSTOMER_LOADED";
export const RELATION_MODEL_NOTE_DELETED = "RELATION_MODEL_NOTE_DELETED";
export const RELATION_MODEL_NOTE_CREATED = "RELATION_MODEL_NOTE_CREATED";
export const RELATION_MODEL_NOTE_UPDATED = "RELATION_MODEL_NOTE_UPDATED";

export const INVENTORY_LIST_FETCHED = "INVENTORY_LIST_FETCHED";
export const INVENTORY_MODEL_LOADED = "INVENTORY_MODEL_LOADED";
export const INVENTORY_MODEL_UPDATED_BY_FORM = "INVENTORY_MODEL_UPDATED_BY_FORM";
export const INVENTORY_MODEL_UPDATED_ON_SERVER = "INVENTORY_MODEL_UPDATED_ON_SERVER";
export const SET_NEW_INVENTORY_ADJUSTMENT_MODEL = "SET_NEW_INVENTORY_ADJUSTMENT_MODEL";
export const INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM = "INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM";
export const INVENTORY_ADJUSTMENT_MODEL_UPDATED_ON_SERVER = "INVENTORY_ADJUSTMENT_MODEL_UPDATED_ON_SERVER";

export const ORDER_LIST_FETCHED = "ORDER_LIST_FETCHED";
export const ORDER_MODEL_LOADED = "ORDER_MODEL_LOADED";
export const ORDER_MODEL_UPDATED_BY_FORM = "ORDER_MODEL_UPDATED_BY_FORM";
export const ORDER_LINE_UPDATED_BY_FORM = "ORDER_LINE_UPDATED_BY_FORM";
export const ORDER_MODEL_UPDATED_ON_SERVER = "ORDER_MODEL_UPDATED_ON_SERVER";
export const ORDER_LINE_ADDED_TO_MODEL = "ORDER_LINE_ADDED_TO_MODEL";
export const ORDER_LINE_UPDATED_OF_UNSAVED_MODEL = "ORDER_LINE_UPDATED_OF_UNSAVED_MODEL";
export const ORDER_LINE_DELETED_OF_MODEL = "ORDER_LINE_DELETED_OF_MODEL";
export const ORDER_STATUS_UPDATED = "ORDER_STATUS_UPDATED";
export const UPDATE_ORDER_HOLD_REASON = "UPDATE_ORDER_HOLD_REASON";
export const ORDER_NOTE_ADDED = "ORDER_NOTE_ADDED";
export const ORDER_NOTE_DELETE = "ORDER_NOTE_DELETE";

export const SET_NEW_SHIPMENT_MODEL = "SET_NEW_SHIPMENT_MODEL";
export const SHIPMENT_MODEL_LOADED = "SHIPMENT_MODEL_LOADED";
export const SHIPMENT_IS_FULFILLED = "SHIPMENT_IS_FULFILLED";
export const SHIPMENT_IS_UNFULFILLED = "SHIPMENT_IS_UNFULFILLED";
export const SHIPMENT_MODEL_UPDATED_BY_FORM = "SHIPMENT_MODEL_UPDATED_BY_FORM";
export const SHIPMENT_LIST_FETCHED = "SHIPMENT_LIST_FETCHED";
export const NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM = "NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM";
export const NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM = "NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM";
export const NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM = "NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM";
export const TRANSACTION_LIST_FETCHED = "TRANSACTION_LIST_FETCHED";
export const TRANSACTION_DOC_NUMBER_UPDATED = "TRANSACTION_DOC_NUMBER_UPDATED";
export const SET_SHIPMENT_IN_TRANSACTION_MODEL = "SET_SHIPMENT_IN_TRANSACTION_MODEL";
export const SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM = "SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM";
export const SHIPMENT_LINE_PRICE_UPDATED_BY_FORM = "SHIPMENT_LINE_PRICE_UPDATED_BY_FORM";
export const SHIPMENT_INVOICE_DATE_UPDATED = "SHIPMENT_INVOICE_DATE_UPDATED";
export const SHIPMENT_ORDER_TAX_CODE_UPDATED = "SHIPMENT_ORDER_TAX_CODE_UPDATED";

export const USER_LIST_FETCHED = "USER_LIST_FETCHED";
export const USER_MODEL_LOADED = "USER_MODEL_LOADED";
export const USER_MODEL_UPDATED_BY_FORM = "USER_MODEL_UPDATED_BY_FORM";
export const USER_MODEL_UPDATED_ON_SERVER = "USER_MODEL_UPDATED_ON_SERVER";
export const NEW_USER_CREATED = "NEW_USER_CREATED";
export const EXISTING_USER_UPDATED = "EXISTING_USER_UPDATED";

export const SET_RETURN_MODEL = "SET_RETURN_MODEL";
export const RETURN_MODEL_UPDATED_BY_FORM = " RETURN_MODEL_UPDATED_BY_FORM";
export const RETURN_MODEL_ADDRESS_UPDATED_BY_FORM = " RETURN_MODEL_ADDRESS_UPDATED_BY_FORM";
export const RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM = "RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM";

export const INTEGRATION_LOGS_LIST_FETCHED = "INTEGRATION_LOGS_LIST_FETCHED";
export const INTEGRATION_QB_TAXES_LOADED = "INTEGRATION_QB_TAXES_LOADED";
export const INTEGRATION_QB_TERM_LOADED = "INTEGRATION_QB_TERM_LOADED";
export const INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM = "INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM";
export const INTEGRATION_QB_ACCOUNT_LOADED = "INTEGRATION_QB_ACCOUNT_LOADED";
export const INTEGRATION_QB_CLASS_LOADED = "INTEGRATION_QB_CLASS_LOADED";
export const INTEGRATION_SET_QB_MODEL = "INTEGRATION_SET_QB_MODEL";
export const INTEGRATION_QB_MODEL_UPDATED_BY_FORM = "INTEGRATION_QB_MODEL_UPDATED_BY_FORM";
export const INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM = "INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM";

export const SPR_FILE_HISTORY_LOADED = "SPR_FILE_HISTORY_LOADED";
export const NEW_FILE_UPLOADED = "NEW_FILE_UPLOADED";
export const SPR_TASK_DELETED = "SPR_TASK_DELETED";
export const SPR_TASK_STARTED = "SPR_TASK_STARTED";
export const SPR_PRODUCTS_LOADED = "SPR_PRODUCTS_LOADED";
export const SPR_PRODUCT_LOADED_BY_ID = "SPR_PRODUCT_LOADED_BY_ID";
export const SPR_MODEL_BASIC_VALUE_CHANGE = "SPR_MODEL_BASIC_VALUE_CHANGE";
export const SPR_MODEL_DESCRIPTION_VALUE_CHANGE = "SPR_MODEL_DESCRIPTION_VALUE_CHANGE";
export const SPR_MODEL_DATASHEET_VALUE_CHANGE = "SPR_MODEL_DATASHEET_VALUE_CHANGE";



// WEBPACK FOOTER //
// ./src/actions/types.js